import { render, staticRenderFns } from "./pingPayResultDialog.vue?vue&type=template&id=36b0bfe2"
import script from "./pingPayResultDialog.vue?vue&type=script&lang=js"
export * from "./pingPayResultDialog.vue?vue&type=script&lang=js"
import style0 from "./pingPayResultDialog.vue?vue&type=style&index=0&id=36b0bfe2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports